import { ITranslation } from "./translation.interface";

export class Tools {
  public static downloadBlob(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.download = fileName;
    a.href = url;
    a.click();
  }

  public static openBlob(blob: Blob): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("target", "_blank");
    a.click();
  }

  public static isDefined(elem: unknown): boolean {
    return elem !== null && elem !== undefined;
  }

  public static getDateTimeLocaleFormat(langs: ITranslation[], appLang: string): string {
    const foundLang = langs.find((l) => l.term === appLang);
    if (foundLang && appLang === foundLang.term) {
      return foundLang.timeLocaleFormat;
    } else {
      return "en-EN";
    }
  }

  public static getTranslation(definition: ITranslation, lang: keyof ITranslation, txtBackup: string): string {
    try {
      if (!definition) {
        return txtBackup;
      }
      if (Object.prototype.hasOwnProperty.call(definition, lang)) {
        return definition[lang];
      } else {
        return txtBackup;
      }
    } catch (err) {
      return txtBackup;
    }
  }
}
